export default __webpack_public_path__ + "static/eight-692e81ac30311601f504c1ccc22189ce.jpg";